// extracted by mini-css-extract-plugin
export var anchor = "_4i-0";
export var discard = "_4i-4";
export var muiTooltipTooltip = "_4i-6";
export var notificationBar = "_4i-3";
export var saveButtonHoverSlotWrapper = "_4i-5";
export var show = "_4i-2";
export var spacer = "_4i-1";